<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12"><div class="banner-title">确认信息</div></van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="user-info">
            <div>
                <img class="user-img" :src="user.userAvatar ? user.userAvatar : defaultImg">
            </div>
            <div class="user-name">{{user.userName}}</div>
            <div class="user-phone" v-if="type == 'phone'">{{user.phone}}</div>
            <div class="add-btn" @click="toApply" v-if="!user.status"><span class="add-btn-text">邀请TA</span></div>
            <div class="user-btn" v-if="user.status"><span class="user-btn-text">互为好友</span></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'confirm',
        data() {
            return {
                defaultImg: require('@/assets/share/home/noImg.png'),
                user: {},
                type: '',
            }
        },
        mounted() {
            this.user = JSON.parse(localStorage.getItem("addUser"));
            this.type = this.$route.params.type;
        },
        methods: {
            back() {
                this.$router.back();
            },
            toApply() {
                localStorage.setItem("statusPrivilege", '1');
                localStorage.setItem("ecgPrivilege", '1');
                localStorage.setItem("sportPrivilege", '1');
                localStorage.setItem("sportPrivilege", '1');
                localStorage.setItem("remark", this.user.userName);
                this.$router.push({
                    name: 'apply'
                })
            }
        }
    }
</script>

<style scoped>
    .user-info {
        text-align: center;
        position: relative;
    }

    .user-img {
        width: 50px;
        height: 50px;
        border: 2px solid rgba(255,255,255,0.69);
        margin-top: 20px;
        border-radius: 50%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }

    .user-name {
        font-size: 15px;
        padding-top: 82px;
        color: #ffffff;
        opacity: 0.9;
    }

    .user-phone {
        font-size: 12px;
        color: #ffffff;
        opacity: 0.9;
        margin-top: 8px;
    }

    .add-btn {
        width: 311px;
        height: 44px;
        background: #20D38F;
        opacity: 1;
        border-radius: 22px;
        margin: 30px auto;
        font-size: 15px;
        line-height: 44px;
    }

    .add-btn-text {
        opacity: 0.9;
        color: #ffffff;
    }

    .user-btn {
        width: 311px;
        height: 44px;
        opacity: 1;
        border-radius: 22px;
        margin: 30px auto;
        font-size: 15px;
        line-height: 44px;
        border: 1px solid #7A7A7A;
    }

    .user-btn-text {
        opacity: 0.9;
        color: #7A7A7A;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/confirm.vue